import React from 'react'
import useStyles from './Styles'
import classNames from 'classnames/bind'
import { IProps } from './Interface'
import { Typography } from '@material-ui/core'

const Bean: React.FC<IProps> = ({ angle, size, position, opacity, fill, name, animated, rgbColor, index }) => {
  const classes = useStyles({
    angle,
    size,
    position,
    opacity,
    fill,
    rgbColor,
    index
  })

  const cx = classNames.bind(classes)

  const className = cx({ bean: true, animated, static: !animated })

  return (
    <li className={className}>
      <Typography id={`${index}-snapshot-beans-description-label`} className={classes.beanText}>
        {name}
      </Typography>
    </li>
  )
}

Bean.defaultProps = {
  angle: 0,
  size: {
    height: 80,
    width: 300
  },
  position: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  opacity: 0.5,
  fill: true,
  animated: false,
  name: undefined,
  rgbColor: '255, 255, 255',
  index: 0
}

export default Bean
